var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500977,
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2542_5700",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2542_5700",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEl0lEQVR4nO2dSYxURRjHX9doTEYOamIkxoMxXDwoevAoYfDiARMSiTEsils8yA3QyDaGBKp6IJmARg0xhoskBFcEVDyghoAmk3TVMAvrdE83zAIMywhMd8/ymXoTY5Beanr6varX7/9Lvssk3TP1/fr76lVVZ8rzAAAAAAAAAAAAAACIK1w+y3hqBeNyDeOdHzRmyDV6jF5b6hnPSbbL+5mQm5iQ/UwoilVwlWFCbdA58FygKaleYFwOWk+MsB4DHk8ttCqDcbWKCTXuQDLIieCqyLh8zY4NrhYwIQvWkyAcC66KTclUS7gyWrvmoE2pSlIueq0dzaH5mJ7AHfg0CoeDq/Xh2CBKMCGz1gcsHA+uMjpX4awzbA9WRCM8fnJ+4D5YUq60PVAWlUh2Lg9eCFfrrA9URCS4Whe4kARXH1kfqIhG6FxBiLAvIjJCFu9P05G+Ubo6NkH5iSk6PZKnbceH6aH2LuvJY3ETIk4MUznOXM3Tox93W09gbIS8tD9N1Thw9ob1BMZGyK/pv6sKmSKiJz7rtZ7EWAi5lp8gE179od96EmMhRE/gJrx1OGc9ibEQ0n15zEhIy1fnrCcxFkK2HBuqKiN7o0j3tXVaT2IshDzQ3uU/2pZDN7Ql36StJzA2QnQ89kmPvyj8P7nRYkPKYK4L+Tee3H2KVv6YpTcPZf05o9HaFIuakDhFAkKUdQkQIuwnPnJC3v05ZxRPfXG65Ovnfd5r/B7NO0rPSXquem7PGXr52wy9fThHqw5m/d1n/bOg5jFnhZiy+siFkq9/5fuM8Xs8suvOXWP94PD1qet0e3yy7GtGC5P+5qb+PfckISQQIQ+2d9G+nms0U9SlMVq09zwqpJ5C5u7qNt6uKcX45BS990vpvwUtS8xMiF6A/nnxFtWDjb8PQgibZYV8qUaoXugtnRf39aFC2CyE1Jv09ULNT2F4ygqI5QdqOziDkIDoGLwNIawOLUtv+W89PuwvAt/5KUfJE5eo90r5Y4BK6MUpKkTUJkRPxut/G6R7k3f3/iah6I1DWbpVLL9QLMXrB7MQwmoUsvmPoarJa9l73l9vmLI7NQIhrAYhut/rKjBpL7qFmXIsdxNCWA1Cln6XMU6cXtGbfiOm50oeQlgNQh7/tGdGiTvaX/1LfJqhm+MQwmoQ8vDOmX1xe8dfZm2rMDEFISwEIe8fHTB6X93Y8NgrZn8eUi30DjOEhHhAxSDk7iSYshpCGv8Il6FCIIRht/c/UCFoWVQuBzgPIVQIJnWBCqkI5hDMIYQ5pAKoEFQIoUIqgApBhRAqpAKoEFQIoUIqgAqJSYVQIx3hxjUSEKLiJwT/Jla59W9i/dtzHPj0sWjEssCF6Gt+HBgoRSG8ts6ngxcy3bb6bA+WuR/pUGT4QoTa4MCAye2QH4Z8CZgasD9o5WZwmQv1QhefpHoeVx6pEjJU0drlYPoCLP8iLNufSOFKyIJ/v6FVeGqhvnPJfjKU/TbF1QLPCVo7mvWdS/rJIn4iVJ8/gYc+Z5jCT86fXjzKtQkhRSMGE3Lt9NWrIa0zAAAAAAAAAAAAAADw3OMfz6KuA6wmHaoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.fe6fb55962c9ca068e7a9a7eb081e0b5.svg";
export { ForwardRef as ReactComponent };